import Payment from "../../../components/checkout/mainContentBox/Payment";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import type {ApplicationState} from "../../../reducers";
import {SHIPPING_TYPES} from "../../../models/ShippingTypes";
import { assignPaymentToOrder, setFreePayment } from "../../../actions/order";
import type {PaymentMethod} from "../../../api/PaymentApi";
import type {OrderItemsResponse} from "../../../models/Order";
import {CouponState} from "../../../models/Coupon";
import {CHECKOUT_PAGE_STATUS} from "../../../components/checkout/CheckoutPage";
import {checkoutPageStepSet} from "../../../reducers/orderReducer";

const mapStateToProps = (state: ApplicationState, _ownProps) => {
	const items = state.cart.items;
	const isAllShipping = !(items.some(item => item.shippingMethod !== SHIPPING_TYPES.SHIPPING));
	const myOrder: OrderItemsResponse = state.order.order;

	return {
		isAllShipping,
		paymentMethods: state.cart.paymentMethods,
		paymentFacility: state.cart.paymentFacility,
		paymentErrors: state.cart.assignPaymentErrors,
        paymentAuthorizationFailed: state.order.paymentAuthorizationFailed,
		orderIsCreated: myOrder && myOrder.orderNo,
		orderPayedFullyByCoupon: state.coupon.coupon && state.coupon.coupon.coupon &&
			state.coupon.coupon.couponState && CouponState.isValid(state.coupon.coupon.couponState) &&
			myOrder && myOrder.orderItems && state.order.totalBillingAmount &&
			state.coupon.coupon.coupon.eligibleAmount && state.order.totalBillingAmount.cost <= 0,
	};
};

const mapDispatchToProps = dispatch => {
	return {
        setOrderFullyPayedByCoupon: () => {
            dispatch(setFreePayment());
        },
        assignPaymentMethod: (method: PaymentMethod) => {
            dispatch(assignPaymentToOrder(method));
        },
        nextPage: () => {
            dispatch(checkoutPageStepSet(CHECKOUT_PAGE_STATUS.OVERVIEW));
        }
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Payment));
